export function isLoggingSuppressed(hints?: Map<string, unknown>): boolean {
    return hints?.get('io.gateway.logging.suppress') === true;
}

export const LOG_PREFIX_HINT = 'io.gateway.logging.prefix';

export function getLogPrefix(hints?: Map<string, unknown>): string {
    if (hints?.has(LOG_PREFIX_HINT)) {
        return (hints.get(LOG_PREFIX_HINT) as string) ?? '';
    }
    return '';
}
